import { useModal } from '@shared/model/useModal';

export const useCheckConfModal = () => useModal('check-conf')